import React from 'react';

import styles from '../../contractDetails.module.scss';

interface ServerData {
  type?: string;
  host?: string;
  schema?: string;
  database?: string;
}

interface ServerInfoProps {
  title: string;
  server: ServerData;
}

export function ServerInfo( { title, server }: ServerInfoProps ) {
  return (
    <>
      <h4 className={ styles.subsectionTitle }>{ title }</h4>
      <div className={ styles.serverMetadataRow }>
        { server.type && (
          <div className={ styles.metadataItem }>
            <label>Type</label>
            <span>{ server.type }</span>
          </div>
        ) }
        { server.host && (
          <div className={ styles.metadataItem }>
            <label>Host</label>
            <span>{ server.host }</span>
          </div>
        ) }
        { server.schema && (
          <div className={ styles.metadataItem }>
            <label>Schema</label>
            <span>{ server.schema }</span>
          </div>
        ) }
        { server.database && (
          <div className={ styles.metadataItem }>
            <label>Database</label>
            <span>{ server.database }</span>
          </div>
        ) }
      </div>
    </>
  );
}
